export const partialUrls = [`/cmx/jump`, `/tests/`];
export const exactUrls = [`/`];
